<template>
    <div class="modal fade" id="costumModalLegendaData" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 95vw;height: 95vh;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 90vh;">
                <div class="modal-header">
                    <h4 class="modal-title">Pengaturan Data</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="min-width: 90vw; min-height: 75vh !important;">
                    <div class="row px-2">
                        <div class="col-sm-12">
                            Pengaturan Data {{ nama_gesiap }} {{ jenis_gesiap }}
                        </div>
                        <div class="col-sm-6 float-left">
                            <label>PIU <small class="text-info"> (*wajib
                                    dipilih)</small></label>
                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'ACTION 4')
                                && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')) ? 'display:block' : 'display:none']">
                            <label>Kabupaten / Kota <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;display: none;"></v-select>
                            <v-select multiple :options="lokasi" :reduce="(label) => label.code" label="label"
                                @option:selected="onlokasiChangeSelect($event)"
                                @option:deselected="onlokasiChangeDeselect($event)" v-model="arraynamalokasi"
                                id="lokasiku" style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')) ? 'display:block' : 'display:none']">
                            <label>Paket Pekerjaan<small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="paket_pekerjaan" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedpaket_pekerjaan" @update:modelValue="onpaket_pekerjaanChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')
                                || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8')) ? 'display:block' : 'display:none']">
                            <label>Nama Penyedia <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="penyedia" name="penyedia"
                                    placeholder="Nama Penyedia" v-model="penyedia">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8')
                                && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')) ? 'display:block' : 'display:none']">
                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="kegiatan" name="kegiatan"
                                    placeholder="Nama Kegiatan" v-model="kegiatan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8')
                                && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12')) ? 'display:block' : 'display:none']">
                            <label>Tanggal <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="date" class="form-control form-control-sm" id="tanggal" name="tanggal"
                                    placeholder="Tanggal" v-model="tanggal">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12')) ? 'display:block' : 'display:none']">
                            <label>Progres <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="progres" name="progres"
                                    placeholder="Progres" v-model="progres">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12')) ? 'display:block' : 'display:none']">
                            <label>DMF (Ada/Tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="dmf" value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="dmf" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12')) ? 'display:block' : 'display:none']">
                            <label>GAP (Ada/Tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="gap" value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="gap" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')) ? 'display:block' : 'display:none']">
                            <label>Praktik Baik (Ada/Tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="praktek" value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="praktek" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')) ? 'display:block' : 'display:none']">
                            <label>Pembelajaran (Ada/Tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="pembelajaran" value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="pembelajaran" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')) ? 'display:block' : 'display:none']">
                            <label>Tempat Kegiatan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="namalokasi"
                                    name="namalokasi" placeholder="Tempat Kegiatan" v-model="namalokasi">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')) ? 'display:block' : 'display:none']">
                            <label>Sasaran orientasi <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="sasaran_orientasi" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedsasaran_orientasi"
                                @update:modelValue="onsasaran_orientasiChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;display: none;"></v-select>
                            <v-select multiple :options="sasaran_orientasi" :reduce="(label) => label.code"
                                label="label" @option:selected="onsasaran_orientasiChangeSelect($event)"
                                @option:deselected="onsasaran_orientasiChangeDeselect($event)"
                                v-model="arraynamasasaran_orientasi" id="sasaran_orientasiku"
                                style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4')) ? 'display:block' : 'display:none']">
                            <label>Jenis media yang digunakan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="media" name="media"
                                    placeholder="Jenis media yang digunakan" v-model="media">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4')) ? 'display:block' : 'display:none']">
                            <label>Nama/ alamat media <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama_media"
                                    name="nama_media" placeholder="Nama/ alamat media" v-model="nama_media">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3')) ? 'display:block' : 'display:none']">
                            <label>Jumlah jenis media <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="jumlah_jenis_media"
                                    name="jumlah_jenis_media" placeholder="Jumlah jenis media"
                                    v-model="jumlah_jenis_media">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')) ? 'display:block' : 'display:none']">
                            <label>Topik Pada Bagian BAB/Sub BAB <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="topik" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedtopik" @update:modelValue="ontopikChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4')) ? 'display:block' : 'display:none']">
                            <label>Keterlibatan Organisasi /kelompok Perempuan <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="arrayorganisasi_perempuan" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedorganisasi_perempuan"
                                @update:modelValue="onorganisasi_perempuanChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4')) ? 'display:block' : 'display:none']">
                            <label>Keterlibatan Organisasi penyandang disabilitas <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="arrayorganisasi_difabel" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedorganisasi_difabel"
                                @update:modelValue="onorganisasi_difabelChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Terampil Perempuan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_terampil_perempuan" name="pekerja_terampil_perempuan"
                                    placeholder="Pekerja Terampil Perempuan" v-model="pekerja_terampil_perempuan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Terampil Perempuan Disabilitas <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_terampil_perempuan_difabel" name="pekerja_terampil_perempuan_difabel"
                                    placeholder="Pekerja Terampil Perempuan Disabilitas"
                                    v-model="pekerja_terampil_perempuan_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Terampil Laki-laki <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="pekerja_terampil_laki"
                                    name="pekerja_terampil_laki" placeholder="Pekerja Terampil Laki-laki"
                                    v-model="pekerja_terampil_laki">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Terampil Laki-laki Disabilitas <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_terampil_laki_difabel" name="pekerja_terampil_laki_difabel"
                                    placeholder="Pekerja Terampil Laki-laki Disabilitas"
                                    v-model="pekerja_terampil_laki_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Tidak Terampil Perempuan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_tdk_terampil_perempuan" name="pekerja_tdk_terampil_perempuan"
                                    placeholder="Pekerja Tidak Terampil Perempuan"
                                    v-model="pekerja_tdk_terampil_perempuan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Tidak Terampil Perempuan Disabilitas <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_tdk_terampil_perempuan_difabel"
                                    name="pekerja_tdk_terampil_perempuan_difabel"
                                    placeholder="Pekerja Tidak Terampil Perempuan Disabilitas"
                                    v-model="pekerja_tdk_terampil_perempuan_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Tidak Terampil Laki-laki <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="pekerja_tdk_terampil_laki"
                                    name="pekerja_tdk_terampil_laki" placeholder="Pekerja Tidak Terampil Laki-laki"
                                    v-model="pekerja_tdk_terampil_laki">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Pekerja Tidak Terampil Laki-laki Disabilitas <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm"
                                    id="pekerja_tdk_terampil_laki_difabel" name="pekerja_tdk_terampil_laki_difabel"
                                    placeholder="Pekerja Tidak Terampil Laki-laki Disabilitas"
                                    v-model="pekerja_tdk_terampil_laki_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8')) ? 'display:block' : 'display:none']">
                            <label>Tipe Disabilitas <small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="tipe_difabel" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedtipe_difabel" @update:modelValue="ontipe_difabelChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1')) ? 'display:block' : 'display:none']">
                            <label>Jenis Pelatihan<small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="pelatihan" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedpelatihan" @update:modelValue="onpelatihanChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')) ? 'display:block' : 'display:none']">
                            <label>Responsif Gender Dokumen RPJMD <small class="text-info"> (*wajib
                                    dipilih)</small></label>
                            <select class="form-control form-control-sm">
                                <option value="0" :selected="rpjmd == '0'">Belum Ada</option>
                                <option value="1" :selected="rpjmd == '1'">Ada</option>
                            </select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')) ? 'display:block' : 'display:none']">
                            <label>Responsif Gender Dokumen RTRW <small class="text-info"> (*wajib
                                    dipilih)</small></label>
                            <select class="form-control form-control-sm">
                                <option value="0" :selected="rtrw == '0'">Belum Ada</option>
                                <option value="1" :selected="rtrw == '1'">Ada</option>
                            </select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')) ? 'display:block' : 'display:none']">
                            <label>Responsif Gender Dokumen Rencana FRM <small class="text-info"> (*wajib
                                    dipilih)</small></label>
                            <select class="form-control form-control-sm">
                                <option value="0" :selected="rencana_frm == '0'">Belum Ada</option>
                                <option value="1" :selected="rencana_frm == '1'">Ada</option>
                            </select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Nama <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama_personil"
                                    name="nama_personil" placeholder="Nama" v-model="nama_personil">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Posisi <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="posisi" name="posisi"
                                    placeholder="Posisi" v-model="posisi">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Mobilisasi <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="date" class="form-control form-control-sm" id="mobilisasi"
                                    name="mobilisasi" placeholder="Mobilisasi" v-model="mobilisasi">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Demobilisaisi <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="date" class="form-control form-control-sm" id="demobilisasi"
                                    name="demobilisasi" placeholder="Demobilisaisi" v-model="demobilisasi">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Jumlah Peserta Perempuan <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="jml_perempuan"
                                    name="jml_perempuan" placeholder="Jumlah Peserta Perempuan" v-model="jml_perempuan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10')) ? 'display:block' : 'display:none']">
                            <label>Jumlah Peserta Laki-laki <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="jml_laki" name="jml_laki"
                                    placeholder="Jumlah Peserta Laki-laki" v-model="jml_laki">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3')) ? 'display:block' : 'display:none']">
                            <label>Keterlibatan Organisasi Perempuan (jumlah)<small class="text-info">
                                    (*wajib diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="organisasi_perempuan"
                                    name="organisasi_perempuan" placeholder="Keterlibatan Organisasi Perempuan (jumlah)"
                                    v-model="jmlorganisasi_perempuan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3')) ? 'display:block' : 'display:none']">
                            <label>Keterlibatan Individu penyandang disabilitas (jumlah)<small class="text-info">
                                    (*wajib diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="jumlah_difabel"
                                    name="jumlah_difabel" placeholder="Individu penyandang disabilitas (jumlah)"
                                    v-model="jumlah_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5')) ? 'display:block' : 'display:none']">
                            <label>Keterlibatan Organisasi penyandang disabilitas (jumlah)<small class="text-info">
                                    (*wajib diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="organisasi_difabel"
                                    name="organisasi_difabel" placeholder="Organisasi penyandang disabilitas (jumlah)"
                                    v-model="jmlorganisasi_difabel">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3')) ? 'display:block' : 'display:none']">
                            <label>Hasil Ukur<small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="hasil_ukur" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedhasil_ukur" @update:modelValue="onhasil_ukurChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3')) ? 'display:block' : 'display:none']">
                            <label>Capaian Peningkatan (%) <small class="text-info">
                                    (*wajib diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="number" class="form-control form-control-sm" id="capaian" name="capaian"
                                    placeholder="Capaian Peningkatan (%)" v-model="capaian">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap != 'DMF 1e' && jenis_gesiap != 'TARGET 3') && (nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 2')
                                && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 6') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8')) ? 'display:block' : 'display:none']">
                            <label>Isu-isu responsif gender telah dimasukkan<small class="text-info">
                                    (*wajib dipilih)</small></label>
                            <v-select :options="sudahbelum" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedsudahbelum" @update:modelValue="onsudahbelumChange"
                                style="background-color: #ffffff;color: black;padding-bottom: 10px;"></v-select>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 1a' && jenis_gesiap == 'ACTION 1')) ? 'display:block' : 'display:none']">
                            <label>Dimasukkan Pada Bagian <small class="text-info"> (*wajib
                                    diisi)</small></label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="dimasukkan_bagian"
                                    name="dimasukkan_bagian" placeholder="Dimasukkan Pada Bagian"
                                    v-model="dimasukkan_bagian">
                            </div>
                        </div>
                        <div class="col-sm-12"
                            :style="[((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')) ? 'display:block' : 'display:none']">
                            <label>Diskripsi isi peraturan bangunan ( desain bangunan/fasilitas dll) </label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <quill-editor v-model:value="deskripsi"
                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')) ? 'display:block' : 'display:none']">
                            &nbsp;</div>
                        <div class="col-sm-12"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')) ? 'display:block' : 'display:none']">
                            <label>Data Posisi </label>
                            <div class="table-responsive table-wrapper">
                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                    <thead>
                                        <th style="width: 50px;" class="text-center">
                                            Opsi
                                        </th>
                                        <th style="width: 20px;" class="text-center">
                                            No
                                        </th>
                                        <th style="width: 200px;">
                                            Nama Posisi dan/atau Posisi yang setara
                                        </th>
                                        <th style="width: 50px;">
                                            Upah Perempuan yang diterima/bulan (Rp)
                                        </th>
                                        <th style="width: 50px;">
                                            Upah Laki-laki yang diterima/bulan (Rp)
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(nama_posisisetuju, counternama_posisi) in nama_posisi"
                                            v-bind:key="counternama_posisi">
                                            <td>
                                                <div class="col-sm-12 text-center">
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        @click="addnama_posisi"><i
                                                            class="far fa-plus-square"></i></button>
                                                    <button type="button" class="btn btn-warning btn-sm"
                                                        @click="deletenama_posisi(counternama_posisi)"
                                                        v-if="(counternama_posisi > 0)"><i
                                                            class="far fa-minus-square"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                {{ counternama_posisi + 1 }}
                                            </td>
                                            <td>
                                                <input type="text" :id="'nama_posisi' + (counternama_posisi + 1)"
                                                    :name="'nama_posisi' + (counternama_posisi + 1)"
                                                    class="form-control form-control-sm"
                                                    :placeholder="'Nama Posisi ' + (counternama_posisi + 1)"
                                                    v-model="nama_posisisetuju.nama_posisi">
                                            </td>
                                            <td>
                                                <input type="text" :id="'upahperempuan' + (counternama_posisi + 1)"
                                                    :name="'upahperempuan' + (counternama_posisi + 1)"
                                                    class="form-control form-control-sm"
                                                    :placeholder="'Upah Perempuan ' + (counternama_posisi + 1)"
                                                    v-model="nama_posisisetuju.upahperempuan"
                                                    @keyup="formattulisrupiah('upahperempuan' + (counternama_posisi + 1))"
                                                    @keydown="formattulisrupiah('upahperempuan' + (counternama_posisi + 1))">
                                            </td>
                                            <td>
                                                <input type="text" :id="'upahlakilaki' + (counternama_posisi + 1)"
                                                    :name="'upahlakilaki' + (counternama_posisi + 1)"
                                                    class="form-control form-control-sm"
                                                    :placeholder="'Upah Laki-laki ' + (counternama_posisi + 1)"
                                                    v-model="nama_posisisetuju.upahlakilaki"
                                                    @keyup="formattulisrupiah('upahlakilaki' + (counternama_posisi + 1))"
                                                    @keydown="formattulisrupiah('upahlakilaki' + (counternama_posisi + 1))">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-sm-12 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8')) ? 'display:block' : 'display:none']">
                            <label>Pelaksanaan GBV-SEAH (Ya/tidak)</label>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Kebijakan</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_kebijakan" value="1" />Ya</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_kebijakan" value="0" />Tidak</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Ditetapkan</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_ditetapkan" value="1" />Ya</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_ditetapkan"
                                                    value="0" />Tidak</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Berfungsi</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_berfungsi" value="1" />Ya</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="gbv_berfungsi" value="0" />Tidak</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')) ? 'display:block' : 'display:none']">
                            <label>Fasilitas Dasar Bagi Pekerja/Staf Disabilitas (tersedia/ tidak)</label>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Toilet</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_difabel"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_difabel" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: powderblue;">
                                            <span>Air Besih</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_difabel"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_difabel" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightsteelblue;">
                                            <span>Kemudahan diakses/ramah disabilitas</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_difabel"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_difabel" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')) ? 'display:block' : 'display:none']">
                            <label>Fasilitas Dasar Bagi Pekerja/Staf Perempuan (tersedia/ tidak)</label>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Toilet</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_perempuan"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_perempuan" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: powderblue;">
                                            <span>Air Besih</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_perempuan"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_perempuan" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightsteelblue;">
                                            <span>Kemudahan diakses</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_perempuan"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_perempuan" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')) ? 'display:block' : 'display:none']">
                            <label>Fasilitas Dasar Bagi Pekerja/Staf Laki-laki (tersedia/ tidak)</label>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightskyblue;">
                                            <span>Toilet</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_laki"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="toilet_laki" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: powderblue;">
                                            <span>Air Besih</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_laki"
                                                    value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="air_bersih_laki" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="row">
                                        <div class="col-sm-12" style="background-color: lightsteelblue;">
                                            <span>Kemudahan diakses</span>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_laki" value="1" />Tersedia</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightsteelblue;">
                                            <label><input type="radio" v-model="akses_laki" value="0" />Tidak
                                                Tersedia</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12"
                            :style="[((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')) ? 'display:block' : 'display:none']">
                            &nbsp;</div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9')) ? 'display:block' : 'display:none']">
                            <label>PPMS/Laporan/progres </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="laporan" name="laporan"
                                    placeholder="PPMS/Laporan/progres" v-model="laporan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9')) ? 'display:block' : 'display:none']">
                            <label>Informasi data terpilah perempuan & laki-laki (Ada/tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="informasidata" value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: lightskyblue;">
                                            <label><input type="radio" v-model="informasidata" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2"
                            :style="[((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9')) ? 'display:block' : 'display:none']">
                            <label>Analisis kesenjangan perempuan & laki-laki (Ada/tidak)</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="analisiskesenjangan"
                                                    value="1" />Ada</label>
                                        </div>
                                        <div class="col-sm-6" style="background-color: powderblue;">
                                            <label><input type="radio" v-model="analisiskesenjangan" value="0" />Tidak
                                                Ada</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left pb-2">
                            <label>Nama Dokumen </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fab fa-creative-commons-share"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama_dokumen"
                                    name="nama_dokumen" placeholder="Nama Dokumen" v-model="nama_dokumen">
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>File <small class="text-info">
                                    (*pdf)</small>
                                &nbsp;
                                <span v-if="filenya_dokumen_gesiap != ''">
                                    <a :href="pdfnyafilenya_dokumen_gesiap + filenya_dokumen_gesiap" target="_blank">
                                        Lihat Dokumen</a>
                                </span>
                            </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-file-pdf"></i></span>
                                </div>
                                <input type="file" class="form-control form-control-sm"
                                    id="fileToUploadfilenya_dokumen_gesiap" name="fileToUploadfilenya_dokumen_gesiap"
                                    placeholder="fileToUpload" style="font-size: smaller;" accept="application/pdf">
                                <input type="hidden" class="form-control form-control-sm" id="filenya_dokumen_gesiap"
                                    name="filenya_dokumen_gesiap" placeholder="File filenya_dokumen_gesiap">
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>Opsi</label>
                            <div class="row">
                                <div class="col-sm-9">
                                    <div class="progress">
                                        <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                                            aria-valuemax="100" style="width:0%" id="persennyafilenya_dokumen_gesiap">
                                            <span id="tulisanpersenfilenya_dokumen_gesiap">0%</span>
                                        </div>
                                    </div>
                                    <br>
                                    <span class="text-success" id="suksesnyafilenya_dokumen_gesiap"></span>
                                </div>
                                <div class="col-sm-3 text-center">
                                    <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                        @click="uploadfile('filenya_dokumen_gesiap', 'application/pdf')">Upload
                                        File</button>
                                    <button type="button" class="btn btn-danger btn-sm lebar"
                                        @click="clearfilepeta('filenya_dokumen_gesiap')">Hapus
                                        File</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>Dokumentasi<small class="text-info"> (*jpg)</small>
                                <span v-if="filenya_gesiap != ''">
                                    <a :href="imagesfilenya_gesiap + filenya_gesiap" target="_blank">
                                        Lihat Dokumentasi</a>
                                </span>
                            </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-file-pdf"></i></span>
                                </div>
                                <input type="file" class="form-control form-control-sm" id="fileToUploadfilenya_gesiap"
                                    name="fileToUploadfilenya_gesiap" placeholder="fileToUpload"
                                    style="font-size: smaller;" accept="image/*">
                                <input type="hidden" class="form-control form-control-sm" id="filenya_gesiap"
                                    name="filenya_gesiap" placeholder="File Beranda">
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>Opsi</label>
                            <div class="row">
                                <div class="col-sm-9">
                                    <div class="progress">
                                        <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                                            aria-valuemax="100" style="width:0%" id="persennyafilenya_gesiap">
                                            <span id="tulisanpersenfilenya_gesiap">0%</span>
                                        </div>
                                    </div>
                                    <br>
                                    <span class="text-success" id="suksesnyafilenya_gesiap"></span>
                                </div>
                                <div class="col-sm-3 text-center">
                                    <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                        @click="uploadfile('filenya_gesiap', 'image/*')">Upload
                                        File</button>
                                    <button type="button" class="btn btn-danger btn-sm lebar"
                                        @click="clearfilepeta('filenya_gesiap')">Hapus
                                        File</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>Kendala </label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <quill-editor v-model:value="kendala"
                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label>Tindak Lanjut </label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <quill-editor v-model:value="tindak_lanjut"
                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-sm-12 text-center">
                        <button type="button" class="btn btn-sm btn-success3 text-white lebar2" @click="simpan()"
                            v-if="(dataprosesdata == 'Tambah')" data-toggle="tooltip" data-placement="left"
                            title="Simpan data.."><i class="fas fa-plus-square"></i>
                            Simpan</button>
                        <button type="button" class="btn btn-sm btn-success3 text-white lebar2"
                            v-if="(dataprosesdata != 'Tambah')" @click="update()" data-toggle="tooltip"
                            data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                            Update</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-2 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-10 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Gesiap">GESIAP</a></li>
                                <li class="breadcrumb-item active">Detail GESIAP</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Detail GESIAP</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label>Komponen Indikator</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="Komponen"
                                                    name="Komponen" placeholder="Komponen" v-model="nama_gesiap"
                                                    readonly>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Sub Komponen Indikator </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="SubKomponen"
                                                    name="SubKomponen" placeholder="Sub Komponen Indikator"
                                                    v-model="jenis_gesiap" readonly>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12 text-center p-2">
                                            <button type="button" class="btn btn-primary3 btn-sm text-white lebar2"
                                                @click="prosesdata('Tambah')" data-toggle="tooltip"
                                                data-placement="left" title="Tambah data..">
                                                <i class="fas fa-plus"></i> Tambah
                                            </button>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;">No</th>
                                                            <th style="width: 50px;">Opsi</th>
                                                            <th style="width: 100px;">PIU</th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                    || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                Paket
                                                            </th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')
                                                                    || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                Penyedia
                                                            </th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                Pelaksanaan GBV-SEAH Kebijakan
                                                            </th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                Pelaksanaan GBV-SEAH Ditetapkan
                                                            </th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                Pelaksanaan GBV-SEAH Berfungsi
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Kabupaten / Kota
                                                            </th>
                                                            <th style="width: 150px;"
                                                                v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                    && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7'))">
                                                                Kegiatan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                    && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                Tanggal
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                Progres
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                DMF
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                GAP
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                Praktik Baik
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                Pembelajaran
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                    && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7'))">
                                                                Tempat
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                Jenis media yang digunakan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                Nama/ alamat media
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3'))">
                                                                Jumlah jenis media
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2'))">
                                                                Topik Pada Bagian BAB/Sub BAB
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1'))">
                                                                Pelatihan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                Jumlah Dokumen RPJMD
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                Jumlah Dokumen RTRW
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                Jumlah Dokumen Rencana FRM
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Nama
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Posisi
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Rekrutmen
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Demobilisaisi
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                                                    || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                                                    || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Jumlah Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                                                    || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                                                    || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                    || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                Jumlah Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja terampil Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja terampil Perempuan Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja terampil Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja terampil Laki-laki Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja tidak terampil Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja tidak terampil Perempuan Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja tidak terampil Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Pekerja tidak terampil Laki-laki Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                Tipe Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                Keterlibatan Organisasi Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                    || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                Organisasi penyandang disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3'))">
                                                                Individu penyandang disabilitas (jumlah)
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3'))">
                                                                Hasil Ukur
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3'))">
                                                                Capaian Peningkatan (%)
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap != 'DMF 1e' && jenis_gesiap != 'TARGET 3') && (nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 2')
                                                                    && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 6'))">
                                                                Isu-isu responsif gender telah dimasukkan (sudah/belum)
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1a' && jenis_gesiap == 'ACTION 1'))">
                                                                Dimasukkan pada Bagian
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4'))">
                                                                Diskripsi isi peraturan bangunan ( desain
                                                                bangunan/fasilitas dll)
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Toilet Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Air Bersih Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Akses Disabilitas
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Toilet Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Air Bersih Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Akses Perempuan
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Toilet Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Air Bersih Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                Akses Laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                PPMS / Laporan / progres
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                Informasi data terpilah perempuan & laki-laki
                                                            </th>
                                                            <th style="width: 100px;"
                                                                v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                Analisis kesenjangan perempuan & laki-laki
                                                            </th>
                                                            <th style="width: 100px;">
                                                                Dokumen (pdf)
                                                            </th>
                                                            <th style="width: 100px;">
                                                                Dokumentasi (jpg)
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(datalist, urutlist) in datamaster"
                                                            :key="urutlist">
                                                            <tr>
                                                                <td class="text-center">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-center">
                                                                    <button type="button" style="width: 90px;"
                                                                        class="btn btn-primary3 btn-sm text-white"
                                                                        @click="prosesdata(datalist.id)"
                                                                        data-toggle="tooltip" data-placement="left"
                                                                        title="Edit data.."><i class="fas fa-edit"></i>
                                                                        Edit
                                                                    </button>
                                                                    <button type="button" style="width: 90px;"
                                                                        v-if="roleuser == 'admin'"
                                                                        class="btn btn-warning btn-sm text-white"
                                                                        @click="hapus(datalist.id)"
                                                                        data-toggle="tooltip" data-placement="left"
                                                                        title="Hapus data.."><i
                                                                            class="far fa-trash-alt"></i> Hapus
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    {{ datalist.nama_satker }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                        || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                    {{ datalist.Nama_Kegiatan }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 5') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6')
                                                                        || (nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                    {{ datalist.penyedia }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                    {{ datalist.gbv_kebijakan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                    {{ datalist.gbv_ditetapkan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 8'))">
                                                                    {{ datalist.gbv_berfungsi }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.kabkot }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                        && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7'))">
                                                                    {{ datalist.kegiatan }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                        && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                    {{ G_formatDateNonWIB(datalist.tanggal) }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                    {{ datalist.progres }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                    {{ datalist.dmf }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 12'))">
                                                                    {{ datalist.gap }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                    {{ datalist.praktek }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 11'))">
                                                                    {{ datalist.pembelajaran }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 3') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 7')
                                                                        && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 8') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7'))">
                                                                    {{ datalist.namalokasi }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                    {{ datalist.media }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                    {{ datalist.nama_media }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3'))">
                                                                    {{ G_numFormat(datalist.jumlah_jenis_media) }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2'))">
                                                                    {{ datalist.namatopik }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1'))">
                                                                    {{ datalist.namapelatihan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                    {{ G_numFormat(datalist.rpjmd) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                    {{ G_numFormat(datalist.rtrw) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2'))">
                                                                    {{ G_numFormat(datalist.rencana_frm) }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ datalist.nama_personil }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ datalist.posisi }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ G_formatDateNonWIB(datalist.mobilisasi) }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ G_formatDateNonWIB(datalist.demobilisasi) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                                                        || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                                                        || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ G_numFormat(datalist.jml_perempuan) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1d' && jenis_gesiap == 'TARGET 1') || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 2')
                                                                        || (nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3') || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4')
                                                                        || (nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 2')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 6') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9')
                                                                        || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 7')
                                                                        || (nama_gesiap == '-' && jenis_gesiap == 'ACTION 10'))">
                                                                    {{ G_numFormat(datalist.jml_laki) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{ G_numFormat(datalist.pekerja_terampil_perempuan)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{
                                                                        G_numFormat(datalist.pekerja_terampil_perempuan_difabel)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{ G_numFormat(datalist.pekerja_terampil_laki) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{
                                                                        G_numFormat(datalist.pekerja_terampil_laki_difabel)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{
                                                                        G_numFormat(datalist.pekerja_tdk_terampil_perempuan)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{
                                                                        G_numFormat(datalist.pekerja_tdk_terampil_perempuan_difabel)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 7') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{ G_numFormat(datalist.pekerja_tdk_terampil_laki)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{
                                                                        G_numFormat(datalist.pekerja_tdk_terampil_laki_difabel)
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 8'))">
                                                                    {{ datalist.namatipe_difabel
                                                                    }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3'))">
                                                                    {{ G_numFormat(datalist.organisasi_perempuan) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5') || (nama_gesiap == 'DMF 1h' && jenis_gesiap == 'ACTION 3'))">
                                                                    {{ G_numFormat(datalist.organisasi_difabel) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                    {{ (datalist.namaorganisasi_perempuan) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'TARGET 9') || (nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 4'))">
                                                                    {{ (datalist.namaorganisasi_difabel) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 5'))">
                                                                    {{ G_numFormat(datalist.jumlah_difabel) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3'))">
                                                                    {{ datalist.nama_hasil_ukur }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 1e' && jenis_gesiap == 'TARGET 3'))">
                                                                    {{ G_numFormatKoma(datalist.capaian) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap != 'DMF 1e' && jenis_gesiap != 'TARGET 3') && (nama_gesiap != 'DMF 1h' && jenis_gesiap != 'ACTION 2')
                                                                        && (nama_gesiap != '-' && jenis_gesiap != 'ACTION 10') && (nama_gesiap != 'DMF 2i' && jenis_gesiap != 'ACTION 8') && (nama_gesiap != 'DMF 2h' && jenis_gesiap != 'TARGET 6'))">
                                                                    {{ datalist.namaisu }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1a' && jenis_gesiap == 'ACTION 1'))">
                                                                    {{ datalist.dimasukkan_bagian }}
                                                                </td>
                                                                <td
                                                                    v-if="((nama_gesiap == 'DMF 1' && jenis_gesiap == 'TARGET 4'))">
                                                                    <span v-html="datalist.deskripsi"></span>
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.toilet_difabel }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.air_bersih_difabel }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.akses_difabel }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.toilet_perempuan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.air_bersih_perempuan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.akses_perempuan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.toilet_laki }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.air_bersih_laki }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2h' && jenis_gesiap == 'ACTION 6'))">
                                                                    {{ datalist.akses_laki }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                    {{ datalist.laporan }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                    {{ datalist.informasidata }}
                                                                </td>
                                                                <td class="text-center"
                                                                    v-if="((nama_gesiap == 'DMF 2i' && jenis_gesiap == 'ACTION 9'))">
                                                                    {{ datalist.analisiskesenjangan }}
                                                                </td>
                                                                <td class="text-center">
                                                                    <span v-if="datalist.filenya_dokumen_gesiap != ''">
                                                                        <a :href="pdfnyafilenya_dokumen_gesiap + datalist.filenya_dokumen_gesiap"
                                                                            target="_blank">
                                                                            Lihat Dokumen {{ datalist.nama_dokumen
                                                                            }}</a>
                                                                    </span>
                                                                </td>
                                                                <td class="text-center">
                                                                    <span v-if="datalist.filenya_gesiap != ''">
                                                                        <a :href="imagesfilenya_gesiap + datalist.filenya_gesiap"
                                                                            target="_blank">
                                                                            Lihat Dokumentasi</a>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                    <tbody v-if="datamaster.length == 0">
                                                        <tr>
                                                            <div>Data Kosong</div>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Tutup proses.."><i class="fas fa-window-close"></i>
                                        Tutup</button>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            bahasa: localStorage.getItem("bahasasistem"),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            kode_gesiap: '',
            nama_gesiap: '',
            jenis_gesiap: '',
            kegiatan: '',
            dimasukkan_bagian: '',
            tanggal: '',
            validasi: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            datapesan: '',
            datamaster: [],
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedlokasi: '',
            paramselectedlokasi: [],
            arraynamalokasi: [],
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: '',

            sudahbelum: [],
            datasudahbelum: [],
            defaultSelectedsudahbelum: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedsudahbelum: '',

            pelatihan: [],
            datapelatihan: [],
            defaultSelectedpelatihan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedpelatihan: '',

            hasil_ukur: [],
            datahasil_ukur: [],
            defaultSelectedhasil_ukur: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedhasil_ukur: '',

            kegiatan: '',
            dimasukkan_bagian: '',
            dataprosesdata: '',
            namalokasi: '',
            jml_perempuan: 0,
            jml_laki: 0,
            rpjmd: 0,
            rtrw: 0,
            rencana_frm: 0,
            id: '',
            capaian: 0,
            paket_pekerjaan: [],
            datapaket_pekerjaan: [],
            defaultSelectedpaket_pekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedpaket_pekerjaan: '',
            deskripsi: '',
            jmlorganisasi_perempuan: 0,
            jmlorganisasi_difabel: 0,
            jumlah_difabel: 0,

            topik: [],
            datatopik: [],
            defaultSelectedtopik: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedtopik: '',
            media: '',
            nama_media: '',
            jumlah_jenis_media: 0,
            pekerja_terampil_perempuan: 0,
            pekerja_terampil_laki: 0,
            pekerja_tdk_terampil_perempuan: 0,
            pekerja_tdk_terampil_laki: 0,

            pekerja_terampil_perempuan_difabel: 0,
            pekerja_terampil_laki_difabel: 0,
            pekerja_tdk_terampil_perempuan_difabel: 0,
            pekerja_tdk_terampil_laki_difabel: 0,

            kendala: '',
            tindak_lanjut: '',
            filenya_gesiap: '',
            filenya_dokumen_gesiap: '',
            nama_dokumen: '',
            imagesfilenya_gesiap: process.env.VUE_APP_URL_API + 'parastapainnovation_file_gesiap-Dokumentasi?f=',
            pdfnyafilenya_dokumen_gesiap: process.env.VUE_APP_URL_API + 'parastapainnovation_file_gesiap-PDF?f=',

            tipe_difabel: [],
            datatipe_difabel: [],
            defaultSelectedtipe_difabel: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedtipe_difabel: '',

            arrayorganisasi_perempuan: [],
            dataorganisasi_perempuan: [],
            defaultSelectedorganisasi_perempuan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedorganisasi_perempuan: '',

            arrayorganisasi_difabel: [],
            dataorganisasi_difabel: [],
            defaultSelectedorganisasi_difabel: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedorganisasi_difabel: '',
            penyedia: '',
            counternama_posisi: 0,
            nama_posisi: [
                {
                    previousnama_posisi: '',
                    expirationnama_posisi: ''
                }
            ],

            toilet_difabel: 0,
            air_bersih_difabel: 0,
            akses_difabel: 0,
            toilet_perempuan: 0,
            air_bersih_perempuan: 0,
            akses_perempuan: 0,
            toilet_laki: 0,
            air_bersih_laki: 0,
            akses_laki: 0,
            sasaran_orientasi: [],
            datasasaran_orientasi: [],
            defaultSelectedsasaran_orientasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedsasaran_orientasi: '',
            paramselectedsasaran_orientasi: [],
            arraynamasasaran_orientasi: [],

            gbv_kebijakan: 0,
            gbv_ditetapkan: 0,
            gbv_berfungsi: 0,
            laporan: '',
            informasidata: 0,
            analisiskesenjangan: 0,
            nama_personil: '',
            mobilisasi: '',
            demobilisasi: '',
            posisi: '',
            progres: '',
            praktek: 0,
            pembelajaran: 0,
            dmf: 0,
            gap: 0,

        }
    },
    methods: {
        addnama_posisi() {
            this.nama_posisi.push({
                previousnama_posisi: '',
                expirationnama_posisi: ''
            })
        },
        deletenama_posisi(counternama_posisi) {
            this.nama_posisi.splice(counternama_posisi, 1);
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        onlokasiChangeSelect(events) {
            this.paramselectedlokasi = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedlokasi.push((events[i].tag));
                } catch (error) {

                }
            }

            //alert(JSON.stringify(this.paramselectedlokasi));
        },
        onlokasiChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedlokasi.length; i++) {
                //alert(this.paramselectedlokasi[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedlokasi[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedlokasi[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedlokasi = temparray;
            //alert(JSON.stringify(this.paramselectedlokasi));
        },
        onsasaran_orientasiChangeSelect(events) {
            this.paramselectedsasaran_orientasi = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedsasaran_orientasi.push((events[i].tag));
                } catch (error) {

                }
            }

            //alert(JSON.stringify(this.paramselectedsasaran_orientasi));
        },
        onsasaran_orientasiChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedsasaran_orientasi.length; i++) {
                //alert(this.paramselectedsasaran_orientasi[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedsasaran_orientasi[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedsasaran_orientasi[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedsasaran_orientasi = temparray;
            //alert(JSON.stringify(this.paramselectedsasaran_orientasi));
        },
        onpaket_pekerjaanChange(a) {
            try {
                this.selectedpaket_pekerjaan = this.paket_pekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onsudahbelumChange(a) {
            try {
                this.selectedsudahbelum = this.sudahbelum[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onpelatihanChange(a) {
            try {
                this.selectedpelatihan = this.pelatihan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onhasil_ukurChange(a) {
            try {
                this.selectedhasil_ukur = this.hasil_ukur[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ontopikChange(a) {
            try {
                this.selectedtopik = this.topik[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ontipe_difabelChange(a) {
            try {
                this.selectedtipe_difabel = this.tipe_difabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onorganisasi_perempuanChange(a) {
            try {
                this.selectedorganisasi_perempuan = this.arrayorganisasi_perempuan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onorganisasi_difabelChange(a) {
            try {
                this.selectedorganisasi_difabel = this.arrayorganisasi_difabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
        },
        onsasaran_orientasiChange(a) {
            try {
                this.selectedsasaran_orientasi = this.sasaran_orientasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedsasaran_orientasi);
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_detailgesiap-HapusData", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire({
                                    title: "Informasi",
                                    text: Response.data.message,
                                    icon: "success"
                                }).then(function () {
                                    window.location.reload();
                                });
                                $('.swal2-container').css("z-index", '999999');
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async prosesdata(kode) {
            if (kode == 'Tambah') {
                this.dataprosesdata = 'Tambah';
                this.id = '';
                this.kegiatan = '';
                this.tanggal = '';
                this.dimasukkan_bagian = '';
                this.jml_perempuan = 0;
                this.jml_laki = 0;
                this.rpjmd = 0;
                this.rtrw = 0;
                this.rencana_frm = 0;
                this.namalokasi = '';
                this.capaian = 0;
                this.deskripsi = '';
                this.jmlorganisasi_perempuan = 0;
                this.jmlorganisasi_difabel = 0;
                this.jumlah_difabel = 0;
                this.media = '';
                this.nama_media = '';
                this.jumlah_jenis_media = 0;
                this.pekerja_terampil_perempuan = 0;
                this.pekerja_terampil_laki = 0;
                this.pekerja_tdk_terampil_perempuan = 0;
                this.pekerja_tdk_terampil_laki = 0;
                this.kendala = '';
                this.tindak_lanjut = '';
                this.nama_dokumen = '';
                this.defaultSelectedlokasi = {
                    code: 0,
                    label: 'Pilih Lokasi',
                    tag: '',
                };
                this.selectedlokasi = '';
                this.defaultSelectedsudahbelum = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedsudahbelum = '';
                this.defaultSelectedpelatihan = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedpelatihan = '';
                this.defaultSelectedid_user = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedid_user = '';
                this.defaultSelectedhasil_ukur = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedhasil_ukur = '';
                this.defaultSelectedpaket_pekerjaan = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedpaket_pekerjaan = '';
                this.defaultSelectedtopik = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedtopik = '';
                this.defaultSelectedtipe_difabel = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedtipe_difabel = '';
                this.defaultSelectedorganisasi_perempuan = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedorganisasi_perempuan = '';
                this.defaultSelectedorganisasi_difabel = {
                    code: 0,
                    label: 'Pilih Salah Satu',
                    tag: '',
                };
                this.selectedorganisasi_difabel = '';
                document.getElementById('filenya_gesiap').value = '';
                document.getElementById('filenya_dokumen_gesiap').value = '';
                this.filenya_gesiap = '';
                this.filenya_dokumen_gesiap = '';
                this.pekerja_terampil_perempuan_difabel = 0;
                this.pekerja_terampil_laki_difabel = 0;
                this.pekerja_tdk_terampil_perempuan_difabel = 0;
                this.pekerja_tdk_terampil_laki_difabel = 0;
                this.arraynamalokasi = [];
                this.paramselectedlokasi = [];
                this.counternama_posisi = 0;
                this.nama_posisi = [
                    {
                        previousnama_posisi: '',
                        expirationnama_posisi: ''
                    }
                ];
                this.penyedia = '';
                this.toilet_difabel = 0;
                this.air_bersih_difabel = 0;
                this.akses_difabel = 0;
                this.toilet_perempuan = 0;
                this.air_bersih_perempuan = 0;
                this.akses_perempuan = 0;
                this.toilet_laki = 0;
                this.air_bersih_laki = 0;
                this.akses_laki = 0;
                this.defaultSelectedsasaran_orientasi = {
                    code: 0,
                    label: 'Pilih Lokasi',
                    tag: '',
                };
                this.selectedsasaran_orientasi = '';
                this.arraynamasasaran_orientasi = [];
                this.paramselectedsasaran_orientasi = [];

                this.gbv_kebijakan = 0;
                this.gbv_ditetapkan = 0;
                this.gbv_berfungsi = 0;
                this.laporan = '';
                this.informasidata = 0;
                this.analisiskesenjangan = 0;
                this.nama_personil = '';
                this.mobilisasi = '';
                this.demobilisasi = '';
                this.posisi = '';
                this.progres = '';
                this.praktek = 0;
                this.pembelajaran = 0;
                this.dmf = 0;
                this.gap = 0;
                $('#costumModalLegendaData').modal('show');
            }
            else {
                this.dataprosesdata = 'Edit';
                this.halamanloading = true;
                var mainAPIDataSingel = axios.create({
                    baseURL: process.env.VUE_APP_URL_API,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                    },
                });
                var random = Math.random();
                await mainAPIDataSingel.get("parastapainnovation_detailgesiap-Get?kode=" + kode + "&random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                    Response => {
                        this.id = Response.data.content.data[0].id;
                        this.kegiatan = Response.data.content.data[0].kegiatan;
                        this.tanggal = Response.data.content.data[0].tanggal;
                        this.dimasukkan_bagian = Response.data.content.data[0].dimasukkan_bagian;
                        this.jml_perempuan = Response.data.content.data[0].jml_perempuan;
                        this.jml_laki = Response.data.content.data[0].jml_laki;
                        this.rpjmd = Response.data.content.data[0].rpjmd;
                        this.rtrw = Response.data.content.data[0].rtrw;
                        this.rencana_frm = Response.data.content.data[0].rencana_frm;
                        this.namalokasi = Response.data.content.data[0].namalokasi;
                        this.capaian = Response.data.content.data[0].capaian;
                        this.deskripsi = Response.data.content.data[0].deskripsi;
                        this.jmlorganisasi_perempuan = Response.data.content.data[0].organisasi_perempuan;
                        this.jmlorganisasi_difabel = Response.data.content.data[0].organisasi_difabel;
                        this.organisasi_difabel = Response.data.content.data[0].organisasi_difabel;
                        this.jumlah_difabel = Response.data.content.data[0].jumlah_difabel;
                        this.media = Response.data.content.data[0].media;
                        this.nama_media = Response.data.content.data[0].nama_media;
                        this.jumlah_jenis_media = Response.data.content.data[0].jumlah_jenis_media;
                        this.pekerja_terampil_perempuan = Response.data.content.data[0].pekerja_terampil_perempuan;
                        this.pekerja_terampil_laki = Response.data.content.data[0].pekerja_terampil_laki;
                        this.pekerja_tdk_terampil_perempuan = Response.data.content.data[0].pekerja_tdk_terampil_perempuan;
                        this.pekerja_tdk_terampil_laki = Response.data.content.data[0].pekerja_tdk_terampil_laki;
                        this.kendala = Response.data.content.data[0].kendala;
                        this.tindak_lanjut = Response.data.content.data[0].tindak_lanjut;
                        this.nama_dokumen = Response.data.content.data[0].nama_dokumen;
                        document.getElementById('filenya_gesiap').value = Response.data.content.data[0].filenya_gesiap;
                        document.getElementById('filenya_dokumen_gesiap').value = Response.data.content.data[0].filenya_dokumen_gesiap;
                        this.filenya_gesiap = Response.data.content.data[0].filenya_gesiap;
                        this.filenya_dokumen_gesiap = Response.data.content.data[0].filenya_dokumen_gesiap;
                        this.pekerja_terampil_perempuan_difabel = Response.data.content.data[0].pekerja_terampil_perempuan_difabel;
                        this.pekerja_terampil_laki_difabel = Response.data.content.data[0].pekerja_terampil_laki_difabel;
                        this.pekerja_tdk_terampil_perempuan_difabel = Response.data.content.data[0].pekerja_tdk_terampil_perempuan_difabel;
                        this.pekerja_tdk_terampil_laki_difabel = Response.data.content.data[0].pekerja_tdk_terampil_laki_difabel;

                        var lokasinya = Response.data.content.data[0].tempat;
                        this.arraynamalokasi = [];
                        try {
                            var myArray = lokasinya.split(",");
                        } catch (error) {
                            var myArray = [];
                        }

                        var sasaran_orientasinya = Response.data.content.data[0].sasaran_orientasi;
                        this.arraynamasasaran_orientasi = [];
                        try {
                            var myArraysasaran_orientasi = sasaran_orientasinya.split(",");
                        } catch (error) {
                            var myArraysasaran_orientasi = [];
                        }

                        //alert(myArray.length);

                        const mainAPIDataSingelcari = axios.create({
                            baseURL: process.env.VUE_APP_URL_API,
                            headers: {
                                Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                            },
                        });


                        mainAPIDataSingelcari.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                            Response => {
                                this.datapesan = Response.data.message;
                                //alert(this.datapesan);
                                if (this.datapesan == 'data diketemukan') {
                                    this.datalokasi = [];
                                    this.lokasi = [];
                                    this.datalokasi = Response.data.content.data;
                                    this.datalokasi.forEach((item) => {
                                        for (let i = 0; i < myArray.length; i++) {
                                            if (item.id == myArray[i]) {
                                                //this.arraynamalokasi.push(item.kode_lokasi_lengkap);
                                                this.arraynamalokasi.push({
                                                    label: item.nama,
                                                    code: this.datalokasi.indexOf(item) + 1,
                                                    tag: item.id,
                                                });

                                                this.paramselectedlokasi.push(item.id);
                                            }
                                        }
                                        if (item.id == lokasinya) {
                                            this.defaultSelectedlokasi = {
                                                code: this.datalokasi.indexOf(item) + 1,
                                                label: item.nama,
                                                tag: item.id,
                                            };
                                            this.selectedlokasi = item.id;
                                        }
                                        this.lokasi.push({
                                            label: item.nama,
                                            code: this.datalokasi.indexOf(item) + 1,
                                            tag: item.id,
                                        });
                                    });
                                }
                                this.halamanloading = false;
                            }
                        ).catch(error => {
                            console.log(error);
                            //this.ClearlocalStorage();
                            this.halamanloading = false;
                        });

                        this.lokasi.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].tempat) {
                                this.defaultSelectedlokasi = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedlokasi = Response.data.content.data[0].tempat;
                            }
                        });


                        this.sudahbelum.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].isu) {
                                this.defaultSelectedsudahbelum = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedsudahbelum = Response.data.content.data[0].isu;
                            }
                        });
                        this.pelatihan.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].pelatihan) {
                                this.defaultSelectedpelatihan = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedpelatihan = Response.data.content.data[0].pelatihan;
                            }
                        });
                        this.id_user.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].id_user) {
                                this.defaultSelectedid_user = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedid_user = Response.data.content.data[0].id_user;
                            }
                        });
                        this.hasil_ukur.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].hasil_ukur) {
                                this.defaultSelectedhasil_ukur = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedhasil_ukur = Response.data.content.data[0].hasil_ukur;
                            }
                        });
                        this.paket_pekerjaan.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].paket) {
                                this.defaultSelectedpaket_pekerjaan = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedpaket_pekerjaan = Response.data.content.data[0].paket;
                            }
                        });
                        this.topik.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].topik) {
                                this.defaultSelectedtopik = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedtopik = Response.data.content.data[0].topik;
                            }
                        });
                        this.tipe_difabel.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].tipe_difabel) {
                                this.defaultSelectedtipe_difabel = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedtipe_difabel = Response.data.content.data[0].tipe_difabel;
                            }
                        });
                        this.arrayorganisasi_perempuan.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].organisasi_perempuan) {
                                this.defaultSelectedorganisasi_perempuan = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedorganisasi_perempuan = Response.data.content.data[0].organisasi_perempuan;
                            }
                        });
                        this.arrayorganisasi_difabel.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].organisasi_difabel) {
                                this.defaultSelectedorganisasi_difabel = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedorganisasi_difabel = Response.data.content.data[0].organisasi_difabel;
                            }
                        });
                        this.nama_posisi = [];
                        var nama_posisi = Response.data.content.data[0].nama_posisi;
                        if (nama_posisi != '' && nama_posisi != null && nama_posisi != 'null' && nama_posisi != undefined) {
                            var tempkres = nama_posisi.split("#");
                            for (let i = 0; i < tempkres.length; i++) {
                                var tempp1 = tempkres[i].split("|");
                                this.nama_posisi.push({
                                    nama_posisi: tempp1[0],
                                    upahperempuan: tempp1[1],
                                    upahlakilaki: tempp1[2],
                                });
                            }
                        }
                        this.penyedia = Response.data.content.data[0].penyedia;
                        this.toilet_difabel = Response.data.content.data[0].toilet_difabel;
                        this.air_bersih_difabel = Response.data.content.data[0].air_bersih_difabel;
                        this.akses_difabel = Response.data.content.data[0].akses_difabel;
                        this.toilet_perempuan = Response.data.content.data[0].toilet_perempuan;
                        this.air_bersih_perempuan = Response.data.content.data[0].air_bersih_perempuan;
                        this.akses_perempuan = Response.data.content.data[0].akses_perempuan;
                        this.toilet_laki = Response.data.content.data[0].toilet_laki;
                        this.air_bersih_laki = Response.data.content.data[0].air_bersih_laki;
                        this.akses_laki = Response.data.content.data[0].akses_laki;

                        mainAPIDataSingelcari.get("parastapainnovationgesiap-SasaranOrientasi?random=" + random + "&project_id=" + this.project_id).then(
                            Response => {
                                this.datapesan = Response.data.message;
                                //alert(this.datapesan);
                                if (this.datapesan == 'data diketemukan') {
                                    this.datasasaran_orientasi = [];
                                    this.sasaran_orientasi = [];
                                    this.datasasaran_orientasi = Response.data.content.data;
                                    this.datasasaran_orientasi.forEach((item) => {
                                        for (let i = 0; i < myArraysasaran_orientasi.length; i++) {
                                            if (item.id == myArraysasaran_orientasi[i]) {
                                                //this.arraynamasasaran_orientasi.push(item.kode_sasaran_orientasi_lengkap);
                                                this.arraynamasasaran_orientasi.push({
                                                    label: item.nama,
                                                    code: this.datasasaran_orientasi.indexOf(item) + 1,
                                                    tag: item.id,
                                                });

                                                this.paramselectedsasaran_orientasi.push(item.id);
                                            }
                                        }
                                        if (item.id == sasaran_orientasinya) {
                                            this.defaultSelectedsasaran_orientasi = {
                                                code: this.datasasaran_orientasi.indexOf(item) + 1,
                                                label: item.nama,
                                                tag: item.id,
                                            };
                                            this.selectedsasaran_orientasi = item.kode_sasaran_orientasi;
                                        }
                                        this.sasaran_orientasi.push({
                                            label: item.nama,
                                            code: this.datasasaran_orientasi.indexOf(item) + 1,
                                            tag: item.id,
                                        });
                                    });
                                }
                                this.halamanloading = false;
                            }
                        ).catch(error => {
                            console.log(error);
                            //this.ClearlocalStorage();
                            this.halamanloading = false;
                        });

                        this.sasaran_orientasi.forEach((item) => {
                            if (item.tag == Response.data.content.data[0].sasaran_orientasi) {
                                this.defaultSelectedsasaran_orientasi = {
                                    code: item.code,
                                    label: item.label,
                                    tag: item.tag,
                                };
                                this.selectedsasaran_orientasi = Response.data.content.data[0].sasaran_orientasi;
                            }
                        });

                        this.gbv_kebijakan = Response.data.content.data[0].gbv_kebijakan;
                        this.gbv_ditetapkan = Response.data.content.data[0].gbv_ditetapkan;
                        this.gbv_berfungsi = Response.data.content.data[0].gbv_berfungsi;
                        this.laporan = Response.data.content.data[0].laporan;
                        this.informasidata = Response.data.content.data[0].informasidata;
                        this.analisiskesenjangan = Response.data.content.data[0].analisiskesenjangan;
                        this.nama_personil = Response.data.content.data[0].nama_personil;
                        this.mobilisasi = Response.data.content.data[0].mobilisasi;
                        this.demobilisasi = Response.data.content.data[0].demobilisasi;
                        this.posisi = Response.data.content.data[0].posisi;
                        this.progres = Response.data.content.data[0].progres;
                        this.praktek = Response.data.content.data[0].praktek;
                        this.pembelajaran = Response.data.content.data[0].pembelajaran;
                        this.dmf = Response.data.content.data[0].dmf;
                        this.gap = Response.data.content.data[0].gap;
                        this.halamanloading = false;
                        $('#costumModalLegendaData').modal('show');
                    }
                ).catch(error => {
                    console.log(error);
                    swal.fire('Peringatan', error, 'error');
                    this.halamanloading = false;
                    return false;
                })

            }
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Gesiap");
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_kegiatan-GetProyekKegiatan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapaket_pekerjaan = [];
                        this.paket_pekerjaan = [];
                        this.datapaket_pekerjaan = Response.data.content.data;
                        this.datapaket_pekerjaan.forEach((item) => {
                            this.paket_pekerjaan.push({
                                label: item.nama,
                                code: this.datapaket_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.paket_pekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            })
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });

            const mainAPI9 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            await mainAPI9.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasudahbelum = [];
                        this.sudahbelum = [];
                        this.datasudahbelum = Response.data.content.data;
                        this.datasudahbelum.forEach((item) => {
                            this.sudahbelum.push({
                                label: item.nama,
                                code: this.datasudahbelum.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.sudahbelum.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-MPelatihan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapelatihan = [];
                        this.pelatihan = [];
                        this.datapelatihan = Response.data.content.data;
                        this.datapelatihan.forEach((item) => {
                            this.pelatihan.push({
                                label: item.nama,
                                code: this.datapelatihan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.pelatihan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-HasilUkur?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datahasil_ukur = [];
                        this.hasil_ukur = [];
                        this.datahasil_ukur = Response.data.content.data;
                        this.datahasil_ukur.forEach((item) => {
                            this.hasil_ukur.push({
                                label: item.nama,
                                code: this.datahasil_ukur.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.hasil_ukur.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-Topik?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatopik = [];
                        this.topik = [];
                        this.datatopik = Response.data.content.data;
                        this.datatopik.forEach((item) => {
                            this.topik.push({
                                label: item.nama,
                                code: this.datatopik.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.topik.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-TipeDifabel?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatipe_difabel = [];
                        this.tipe_difabel = [];
                        this.datatipe_difabel = Response.data.content.data;
                        this.datatipe_difabel.forEach((item) => {
                            this.tipe_difabel.push({
                                label: item.nama,
                                code: this.datatipe_difabel.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.tipe_difabel.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            await mainAPI9.get("parastapainnovationgesiap-IyaTidak?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataorganisasi_perempuan = [];
                        this.arrayorganisasi_perempuan = [];
                        this.dataorganisasi_perempuan = Response.data.content.data;
                        this.dataorganisasi_perempuan.forEach((item) => {
                            this.arrayorganisasi_perempuan.push({
                                label: item.nama,
                                code: this.dataorganisasi_perempuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.arrayorganisasi_perempuan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            await mainAPI9.get("parastapainnovationgesiap-IyaTidak?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataorganisasi_difabel = [];
                        this.arrayorganisasi_difabel = [];
                        this.dataorganisasi_difabel = Response.data.content.data;
                        this.dataorganisasi_difabel.forEach((item) => {
                            this.arrayorganisasi_difabel.push({
                                label: item.nama,
                                code: this.dataorganisasi_difabel.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.arrayorganisasi_difabel.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationgesiap-SasaranOrientasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasasaran_orientasi = [];
                        this.sasaran_orientasi = [];
                        this.datasasaran_orientasi = Response.data.content.data;
                        this.datasasaran_orientasi.forEach((item) => {
                            this.sasaran_orientasi.push({
                                label: item.nama,
                                code: this.datasasaran_orientasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.sasaran_orientasi.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        async AmbilDataSingel() {
            var temp = this.secretencData.split("_");
            this.kode_gesiap = temp[0];
            this.nama_gesiap = temp[1];
            this.jenis_gesiap = temp[2];
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.datamaster = [];
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovation_detailgesiap-Get?project_id=" + this.project_id + "&random=" + random + "&nama_gesiap=" + this.nama_gesiap + "&jenis_gesiap=" + this.jenis_gesiap + "&role=" + this.roleuser + "&id_user=" + this.levelinstansi).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                        this.halamanloading = false;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })

        },
        validasidata() {
            if ((this.selectedid_user == '') || (this.selectedid_user === null) || (this.selectedid_user === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih PIU..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            if (this.jenis_gesiap == 'ACTION 1' && this.nama_gesiap == 'DMF 1a') {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }

            if ((this.jenis_gesiap == 'TARGET 1' && this.nama_gesiap == 'DMF 1d')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.selectedpelatihan == '' || this.selectedpelatihan == null || this.selectedpelatihan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Pelatihan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }

            if ((this.jenis_gesiap == 'TARGET 2' && this.nama_gesiap == 'DMF 1e')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }

            if ((this.jenis_gesiap == 'TARGET 3' && this.nama_gesiap == 'DMF 1e')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.selectedhasil_ukur == '' || this.selectedhasil_ukur == null || this.selectedhasil_ukur == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Hasil Ukur',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.capaian == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('capaian').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'TARGET 4' && this.nama_gesiap == 'DMF 1')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }

            }
            if ((this.jenis_gesiap == 'TARGET 5' && this.nama_gesiap == 'DMF 1')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }

            }
            if ((this.jenis_gesiap == 'ACTION 2' && this.nama_gesiap == 'DMF 1h')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.selectedtopik == '' || this.selectedtopik == null || this.selectedtopik == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Topik',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }

            }
            if ((this.jenis_gesiap == 'ACTION 3' && this.nama_gesiap == 'DMF 1h')) {

            }
            if ((this.jenis_gesiap == 'TARGET 6' && this.nama_gesiap == 'DMF 2h')) {
                if (this.kegiatan == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('kegiatan').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.tanggal == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('tanggal').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'TARGET 7' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'TARGET 8' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
                if (this.paramselectedlokasi == [] || this.paramselectedlokasi == null || this.paramselectedlokasi == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Lokasi',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'TARGET 9' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'ACTION 4' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'ACTION 5' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'ACTION 6' && this.nama_gesiap == 'DMF 2h')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'ACTION 7' && this.nama_gesiap == 'DMF 2h')) {

            }
            if ((this.jenis_gesiap == 'ACTION 8' && this.nama_gesiap == 'DMF 2i')) {
                if (this.selectedpaket_pekerjaan == '' || this.selectedpaket_pekerjaan == null || this.selectedpaket_pekerjaan == undefined) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Pilih Paket Pekerjaan',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            if ((this.jenis_gesiap == 'ACTION 9' && this.nama_gesiap == 'DMF 2i')) {

            }
            if ((this.jenis_gesiap == 'ACTION 10' && this.nama_gesiap == '-')) {

            }
            if ((this.jenis_gesiap == 'ACTION 11' && this.nama_gesiap == '-')) {

            }
            if ((this.jenis_gesiap == 'ACTION 12' && this.nama_gesiap == '-')) {
                if (this.progres == '') {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Isikan Data',
                    });
                    document.getElementById('progres').focus();
                    $('.swal2-container').css("z-index", '999999');
                    return false;
                }
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var organisasi_perempuan = 0;
            var organisasi_difabel = 0;

            if (((this.nama_gesiap == 'DMF 2h' && this.jenis_gesiap == 'TARGET 9') || (this.nama_gesiap == 'DMF 2h' && this.jenis_gesiap == 'ACTION 4'))) {
                organisasi_perempuan = this.selectedorganisasi_perempuan;
                organisasi_difabel = this.selectedorganisasi_difabel;
            }
            else {
                organisasi_perempuan = this.jmlorganisasi_perempuan;
                organisasi_difabel = this.jmlorganisasi_difabel;
            }

            var nama_posisi = "";
            for (let i = 1; i <= this.nama_posisi.length; i++) {
                if (i == 1) {
                    nama_posisi = nama_posisi + document.getElementById("nama_posisi" + i).value + "|" + document.getElementById("upahperempuan" + i).value + "|" + document.getElementById("upahlakilaki" + i).value;
                }
                else {
                    nama_posisi = nama_posisi + "#" + document.getElementById("nama_posisi" + i).value + "|" + document.getElementById("upahperempuan" + i).value + "|" + document.getElementById("upahlakilaki" + i).value;
                }
            }

            //return false;
            var fd = new FormData();
            fd.append("project_id", this.project_id);
            fd.append("id_user", this.selectedid_user);
            fd.append("kode_gesiap", this.kode_gesiap);
            fd.append("nama_gesiap", this.nama_gesiap);
            fd.append("jenis_gesiap", this.jenis_gesiap);
            fd.append("kegiatan", this.kegiatan);
            fd.append("isu", this.selectedsudahbelum);
            fd.append("pelatihan", this.selectedpelatihan);
            fd.append("dimasukkan_bagian", this.dimasukkan_bagian);
            fd.append("tanggal", this.tanggal);
            fd.append("jml_perempuan", this.jml_perempuan);
            fd.append("jml_laki", this.jml_laki);
            fd.append("rpjmd", this.rpjmd);
            fd.append("rtrw", this.rtrw);
            fd.append("rencana_frm", this.rencana_frm);
            fd.append("tempat", this.paramselectedlokasi);
            fd.append("namalokasi", this.namalokasi);
            fd.append("hasil_ukur", this.selectedhasil_ukur);
            fd.append("capaian", this.capaian);
            fd.append("paket", this.selectedpaket_pekerjaan);
            fd.append("deskripsi", this.deskripsi);
            fd.append("organisasi_perempuan", organisasi_perempuan);
            fd.append("organisasi_difabel", organisasi_difabel);
            fd.append("jumlah_difabel", this.jumlah_difabel);
            fd.append("topik", this.selectedtopik);
            fd.append("media", this.media);
            fd.append("nama_media", this.nama_media);
            fd.append("jumlah_jenis_media", this.jumlah_jenis_media);
            fd.append("pekerja_terampil_perempuan", this.pekerja_terampil_perempuan);
            fd.append("pekerja_terampil_laki", this.pekerja_terampil_laki);
            fd.append("pekerja_tdk_terampil_perempuan", this.pekerja_tdk_terampil_perempuan);
            fd.append("pekerja_tdk_terampil_laki", this.pekerja_tdk_terampil_laki);
            fd.append("kendala", this.kendala);
            fd.append("tindak_lanjut", this.tindak_lanjut);
            fd.append("filenya_gesiap", document.getElementById('filenya_gesiap').value);
            fd.append("filenya_dokumen_gesiap", document.getElementById('filenya_dokumen_gesiap').value);
            fd.append("nama_dokumen", this.nama_dokumen);
            fd.append("pekerja_terampil_perempuan_difabel", this.pekerja_terampil_perempuan_difabel);
            fd.append("pekerja_terampil_laki_difabel", this.pekerja_terampil_laki_difabel);
            fd.append("pekerja_tdk_terampil_perempuan_difabel", this.pekerja_tdk_terampil_perempuan_difabel);
            fd.append("pekerja_tdk_terampil_laki_difabel", this.pekerja_tdk_terampil_laki_difabel);
            fd.append("tipe_difabel", this.selectedtipe_difabel);
            fd.append("nama_posisi", nama_posisi);
            fd.append("penyedia", this.penyedia);
            fd.append("toilet_difabel", this.toilet_difabel);
            fd.append("air_bersih_difabel", this.air_bersih_difabel);
            fd.append("akses_difabel", this.akses_difabel);
            fd.append("toilet_perempuan", this.toilet_perempuan);
            fd.append("air_bersih_perempuan", this.air_bersih_perempuan);
            fd.append("akses_perempuan", this.akses_perempuan);
            fd.append("toilet_laki", this.toilet_laki);
            fd.append("air_bersih_laki", this.air_bersih_laki);
            fd.append("akses_laki", this.akses_laki);
            fd.append("sasaran_orientasi", this.paramselectedsasaran_orientasi);
            fd.append("gbv_kebijakan", this.gbv_kebijakan);
            fd.append("gbv_ditetapkan", this.gbv_ditetapkan);
            fd.append("gbv_berfungsi", this.gbv_berfungsi);
            fd.append("laporan", this.laporan);
            fd.append("informasidata", this.informasidata);
            fd.append("analisiskesenjangan", this.analisiskesenjangan);
            fd.append("nama_personil", this.nama_personil);
            fd.append("mobilisasi", this.mobilisasi);
            fd.append("demobilisasi", this.demobilisasi);
            fd.append("posisi", this.posisi);
            fd.append("progres", this.progres);
            fd.append("praktek", this.praktek);
            fd.append("pembelajaran", this.pembelajaran);
            fd.append("dmf", this.dmf);
            fd.append("gap", this.gap);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_gesiap-AddDetailGesiap", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire({
                            title: "Informasi",
                            text: Response.data.message,
                            icon: "success"
                        }).then(function () {
                            window.location.reload();
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var organisasi_perempuan = 0;
            var organisasi_difabel = 0;

            if (((this.nama_gesiap == 'DMF 2h' && this.jenis_gesiap == 'TARGET 9') || (this.nama_gesiap == 'DMF 2h' && this.jenis_gesiap == 'ACTION 4'))) {
                organisasi_perempuan = this.selectedorganisasi_perempuan;
                organisasi_difabel = this.selectedorganisasi_difabel;
            }
            else {
                organisasi_perempuan = this.jmlorganisasi_perempuan;
                organisasi_difabel = this.jmlorganisasi_difabel;
            }

            var nama_posisi = "";
            for (let i = 1; i <= this.nama_posisi.length; i++) {
                if (i == 1) {
                    nama_posisi = nama_posisi + document.getElementById("nama_posisi" + i).value + "|" + document.getElementById("upahperempuan" + i).value + "|" + document.getElementById("upahlakilaki" + i).value;
                }
                else {
                    nama_posisi = nama_posisi + "#" + document.getElementById("nama_posisi" + i).value + "|" + document.getElementById("upahperempuan" + i).value + "|" + document.getElementById("upahlakilaki" + i).value;
                }
            }

            var fd = new FormData();
            fd.append("project_id", this.project_id);
            fd.append("id_user", this.selectedid_user);
            fd.append("kode_gesiap", this.kode_gesiap);
            fd.append("nama_gesiap", this.nama_gesiap);
            fd.append("jenis_gesiap", this.jenis_gesiap);
            fd.append("kegiatan", this.kegiatan);
            fd.append("isu", this.selectedsudahbelum);
            fd.append("pelatihan", this.selectedpelatihan);
            fd.append("dimasukkan_bagian", this.dimasukkan_bagian);
            fd.append("tanggal", this.tanggal);
            fd.append("jml_perempuan", this.jml_perempuan);
            fd.append("jml_laki", this.jml_laki);
            fd.append("rpjmd", this.rpjmd);
            fd.append("rtrw", this.rtrw);
            fd.append("rencana_frm", this.rencana_frm);
            fd.append("tempat", this.paramselectedlokasi);
            fd.append("namalokasi", this.namalokasi);
            fd.append("hasil_ukur", this.selectedhasil_ukur);
            fd.append("capaian", this.capaian);
            fd.append("paket", this.selectedpaket_pekerjaan);
            fd.append("deskripsi", this.deskripsi);
            fd.append("organisasi_perempuan", organisasi_perempuan);
            fd.append("organisasi_difabel", organisasi_difabel);
            fd.append("jumlah_difabel", this.jumlah_difabel);
            fd.append("topik", this.selectedtopik);
            fd.append("media", this.media);
            fd.append("nama_media", this.nama_media);
            fd.append("jumlah_jenis_media", this.jumlah_jenis_media);
            fd.append("pekerja_terampil_perempuan", this.pekerja_terampil_perempuan);
            fd.append("pekerja_terampil_laki", this.pekerja_terampil_laki);
            fd.append("pekerja_tdk_terampil_perempuan", this.pekerja_tdk_terampil_perempuan);
            fd.append("pekerja_tdk_terampil_laki", this.pekerja_tdk_terampil_laki);
            fd.append("kendala", this.kendala);
            fd.append("tindak_lanjut", this.tindak_lanjut);
            fd.append("filenya_gesiap", document.getElementById('filenya_gesiap').value);
            fd.append("filenya_dokumen_gesiap", document.getElementById('filenya_dokumen_gesiap').value);
            fd.append("nama_dokumen", this.nama_dokumen);
            fd.append("pekerja_terampil_perempuan_difabel", this.pekerja_terampil_perempuan_difabel);
            fd.append("pekerja_terampil_laki_difabel", this.pekerja_terampil_laki_difabel);
            fd.append("pekerja_tdk_terampil_perempuan_difabel", this.pekerja_tdk_terampil_perempuan_difabel);
            fd.append("pekerja_tdk_terampil_laki_difabel", this.pekerja_tdk_terampil_laki_difabel);
            fd.append("tipe_difabel", this.selectedtipe_difabel);
            fd.append("organisasi_perempuan", this.selectedorganisasi_perempuan);
            fd.append("nama_posisi", nama_posisi);
            fd.append("penyedia", this.penyedia);
            fd.append("toilet_difabel", this.toilet_difabel);
            fd.append("air_bersih_difabel", this.air_bersih_difabel);
            fd.append("akses_difabel", this.akses_difabel);
            fd.append("toilet_perempuan", this.toilet_perempuan);
            fd.append("air_bersih_perempuan", this.air_bersih_perempuan);
            fd.append("akses_perempuan", this.akses_perempuan);
            fd.append("toilet_laki", this.toilet_laki);
            fd.append("air_bersih_laki", this.air_bersih_laki);
            fd.append("akses_laki", this.akses_laki);
            fd.append("sasaran_orientasi", this.paramselectedsasaran_orientasi);
            fd.append("gbv_kebijakan", this.gbv_kebijakan);
            fd.append("gbv_ditetapkan", this.gbv_ditetapkan);
            fd.append("gbv_berfungsi", this.gbv_berfungsi);
            fd.append("laporan", this.laporan);
            fd.append("informasidata", this.informasidata);
            fd.append("analisiskesenjangan", this.analisiskesenjangan);
            fd.append("nama_personil", this.nama_personil);
            fd.append("mobilisasi", this.mobilisasi);
            fd.append("demobilisasi", this.demobilisasi);
            fd.append("posisi", this.posisi);
            fd.append("progres", this.progres);
            fd.append("praktek", this.praktek);
            fd.append("pembelajaran", this.pembelajaran);
            fd.append("dmf", this.dmf);
            fd.append("gap", this.gap);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_gesiap-UpdateDetailGesiap", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire({
                            title: "Informasi",
                            text: Response.data.message,
                            icon: "success"
                        }).then(function () {
                            window.location.reload();
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambilmaster();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        //alert(this.levelinstansi);    
        //alert(this.secretencData);
    }
}
</script>
<style></style>